import { useEffect, useState } from "react"
import { ServerRequest } from "../../../utils/apiweb"
import { REQUEST_METHOD } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import {TIPS} from "../../../consts/tips";

import { useForm, useFormErrors, useManagedContext } from "../../hooks"
import { CheckboxButton, CheckboxButtonGroup, FormError, Modal, FormLabel } from "../../common"
import { isNull, isValidNumber } from "../../../utils/validator"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const IncisoVehiculoModal = (props) => {
    const entityInit = {
        id: -Date.now(),
        codigo: '',
        nombre: '',
        orden: '',
        vehiculoMenor: false,
        codigoSucerp: '',
    }

    const { setIsLoading } = useManagedContext()

    const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, _formReset, formSet] = useForm({
        codigo: '',
        nombre: '',
        orden: '',
        vehiculoMenor: false,
        codigoSucerp: '',
    })

    useEffect(() => {
        const {
            codigo,
            nombre,
            orden,
            vehiculoMenor,
            codigoSucerp,
        } = props.editItem

        setEntity({ ...entityInit, ...props.editItem })
        formSet({
            codigo,
            nombre,
            orden,
            vehiculoMenor,
            codigoSucerp,
        })
    }, [props.editItem])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.codigoSucerp.length < 1) errors.codigoSucerp = VALIDATION_MESSAGE.REQUIRED_SHORT

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (props.editMode === 'view') return errors

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'

        return errors
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0
    }

    const onClickConfirm = () => {
        if (!validate()) return

        setIsLoading(true)

        ServerRequest(
            props.editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.INCISO_VEHICULO,
            props.editMode === 'modify' ? `/${entity.id}` : '',
            { ...entity, ...formValues, orden: parseInt(formValues.orden) ?? 0 },
            res => res.json().then(() => {
                setIsLoading(false)
                props.onConfirm()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            error => {
                onRequestError(error)
                setIsLoading(false)
            },
        )
    }

    const disabled = props.editMode === 'view'

    return (
        <Modal
            size="md"
            onEscape={props.onCancel}
            title={`Inciso vehículo: ${props.editItem === 'add' ? 'Nuevo' : entity.nombre}`}
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            body={(
                <div className="row form-basic">
                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-8">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>

                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="codigoSucerp" required>Código Suats</FormLabel>
                        <input
                            type="text"
                            name="codigoSucerp"
                            className={`form-control ${errorOf('codigoSucerp') ? 'is-invalid' : ''}`}
                            value={formValues.codigoSucerp}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigoSucerp')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                            type="number"
                            name="orden"
                            className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                            value={formValues.orden}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>
                    <div className="col-12 col-md-6">
                        <CheckboxButtonGroup label="Clasificación">
                            <CheckboxButton
                                name="vehiculoMenor"
                                label="Es vehículo menor"
                                checked={formValues.vehiculoMenor}
                                onChange={formHandle}
                                disabled={disabled}
                            />
                        </CheckboxButtonGroup>
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                    {props.editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={onClickConfirm}>Guardar</button>
                    )}
                </div>
            )}
        />
    )
}

export default IncisoVehiculoModal
